import { render, staticRenderFns } from "./beneficiaryPlanInformation.vue?vue&type=template&id=41bc48ca&"
import script from "./beneficiaryPlanInformation.vue?vue&type=script&lang=js&"
export * from "./beneficiaryPlanInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports